/**
 *               .__               
 *  ___  __ ____ |__| ______ ______
 *  \  \/ // __ \|  |/  ___//  ___/
 *   \   /\  ___/|  |\___ \ \___ \ 
 *    \_/  \___  >__/____  >____  >
 *             \/        \/     \/ 
 *
 *  Client for handle http requests in JS apps
 *  Uses Axios for the requests
 *  iban@veiss.com
 * 
 */

import axios from 'axios'

/**
 * Create an axios instance
 * 
 */

const url = process.env.VUE_APP_API_URL

const httpClient = axios.create({
    baseURL: `${url}`,
    timeout: 100000,
});

export default httpClient
